import { Headphones } from 'lucide-react';
import { useUser } from '@/shared/hooks/useAuth';
import { SessionCard } from '../components/SessionCard';
import { BreakControls } from '../components/BreakControls';
import { TeamMonitor } from '../components/TeamMonitor';

export function CallCenterPage() {
  const user = useUser();
  const isPrivileged = ['admin', 'superadmin'].includes(user?.role ?? '');

  return (
    <div className="flex h-full flex-col gap-4 p-6">
      <div className="flex items-center gap-3">
        <Headphones className="h-6 w-6 text-primary" />
        <div>
          <h1 className="text-display-sm font-semibold text-on-surface">Call Center</h1>
          <p className="text-body-sm text-on-surface-variant">Your call session, breaks, and team activity.</p>
        </div>
      </div>

      {/* Self view — all roles */}
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <SessionCard />
        <BreakControls />
      </div>

      {/* Team monitoring — admin / superadmin only (mirrors backend) */}
      {isPrivileged && <TeamMonitor enabled={isPrivileged} />}
    </div>
  );
}
